import { useContext, useEffect, useState } from 'react'
import { AppContext } from '@state/context'
import useSWR from 'swr'
import { Library_Sections } from '@graphql/queries'

const useLibrarySections = () => {
  const [state] = useContext(AppContext)
  const userId = state?.app?.userId
  const { data, error, mutate, isValidating } = useSWR(Library_Sections)
  const [sections, setSections] = useState([])

  useEffect(() => {
    if (data?.librarySections?.data) {
      setSections(data.librarySections.data)
    }
  }, [userId, data, isValidating])

  return {
    sections,
    error,
    mutate,
    isValidating,
    isLoading: !error && !data,
  }
}

export { useLibrarySections }
